/** Anzeige-Hilfen. */

export interface PieceName {
  title: string;
  artist: string;
}

/**
 * Dateinamen folgen meist „Titel - Interpret - Arrangeur“. Daraus werden
 * Titel und Untertitel („Interpret · Arrangeur“).
 */
export function splitTitle(raw: string): PieceName {
  const parts = raw
    .split(/\s+[-–]\s+/)
    .map((part) => part.trim())
    .filter(Boolean);
  if (parts.length <= 1) return { title: raw.trim(), artist: "" };
  return { title: parts[0]!, artist: parts.slice(1).join(" · ") };
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(1).replace(".", ",")} MB`;
  return `${(bytes / 1024 / 1024 / 1024).toFixed(2).replace(".", ",")} GB`;
}

export function plural(count: number, one: string, many: string): string {
  return `${count} ${count === 1 ? one : many}`;
}

export function formatDuration(totalSeconds: number): string {
  const minutes = Math.round(totalSeconds / 60);
  if (minutes < 60) return `ca. ${minutes} min`;
  const hours = Math.floor(minutes / 60);
  return `ca. ${hours} h ${minutes % 60} min`;
}

const relative = new Intl.RelativeTimeFormat("de", { numeric: "auto" });

export function formatRelative(ms: number | null, now = Date.now()): string {
  if (!ms) return "nie";
  const diff = (ms - now) / 1000;
  const abs = Math.abs(diff);
  if (abs < 60) return "gerade eben";
  if (abs < 3600) return relative.format(Math.round(diff / 60), "minute");
  if (abs < 86_400) return relative.format(Math.round(diff / 3600), "hour");
  if (abs < 86_400 * 30) return relative.format(Math.round(diff / 86_400), "day");
  return new Date(ms).toLocaleDateString("de-DE");
}

export function greeting(date = new Date()): string {
  const hour = date.getHours();
  if (hour < 11) return "Guten Morgen";
  if (hour < 18) return "Hallo";
  return "Guten Abend";
}
